import React from "react";
import { Link, useLocation } from "react-router-dom";

const FeesActions = () => {
  const { pathname } = useLocation();

  const isActive = (to) => pathname === to;

  return (
    <div className="billing-action-bar mb-4">
      {/* Left group */}
      <div className="action-group-left">
        <Link
          to="/school-fees-new"
          className={`btn-primary-custom ${isActive("/school-fees-new") ? "is-active" : ""}`}
        >
          <i className="fa fa-handshake" />
          <span>New Payment</span>
        </Link>

        <div className="action-separator" />

        <Link
          to="/school-fees-billing"
          className={`btn-ghost-custom ${isActive("/school-fees-billing") ? "is-active" : ""}`}
        >
          <i className="fa fa-money-bill" />
          <span>Billing Center</span>
        </Link>

        <Link
          to="/school-fees-online"
          className={`btn-ghost-custom ${isActive("/school-fees-online") ? "is-active" : ""}`}
        >
          <i className="fab fa-amazon-pay" />
          <span>Online Payments</span>
        </Link>
      </div>

      {/* Right group */}
      <div className="action-group-right">
        <Link
          to="/school-fees-students"
          className={`btn-ghost-custom ${isActive("/school-fees-students") ? "is-active" : ""}`}
        >
          <i className="fa fa-users" />
          <span>Students</span>
        </Link>
      </div>
    </div>
  );
};

export default FeesActions;
